import { RouteLegTypeEnum } from '@/api/apis/route';
import { Uuid } from '@/api/types';

export enum MultiSuggestSegmentEnum {
  EmptyToDH = 'EmptyToDH',
  EmptyToTX = 'EmptyToTX',
  TeamToDH = 'TeamToDH',
  DHToTX = 'DHToTX',
  TeamToHub = 'TeamToHub',
  DeviceToHub = 'DeviceToHub',
  EmptyToAviaHub = 'EmptyToAviaHub',
  Accommodation = 'Accommodation',
}

export type MultiSuggestLegItem = {
  id: Uuid;
  segmentType: MultiSuggestSegmentEnum;
  departureLocationId: string;
  arrivalLocationId: string;
  departureTime: string;
  arrivalTime: string;
  departureLocalTimezone: string;
  arrivalLocalTimezone: string;
  timeDurationInMs: number;
};

export type MultiSuggestSegmentItem = {
  segmentType: MultiSuggestSegmentEnum;
  legs: MultiSuggestLegItem[];
};

export type MultiSuggestRouteItem = {
  providerType: RouteLegTypeEnum;
  title?: string;
  routeDurationInMs?: number;
  blockTimeRouteDurationInMs: number;
  segments: MultiSuggestSegmentItem[];
};
